var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8_dashboard",
    d: "M11,4a7,7,0,1,0,7,7A7.008,7.008,0,0,0,11,4Zm0,1.05A5.95,5.95,0,1,1,5.05,11,5.942,5.942,0,0,1,11,5.05Zm0,.525a.525.525,0,1,0,.525.525A.525.525,0,0,0,11,5.575ZM7.536,7.011a.525.525,0,1,0,.525.525A.525.525,0,0,0,7.536,7.011Zm6.929,0a.525.525,0,1,0,.525.525A.525.525,0,0,0,14.464,7.011Zm.21,2.315a21.052,21.052,0,0,0-3.942,1.027.7.7,0,0,0,.536,1.293c.357-.148,3.76-1.9,3.612-2.254C14.862,9.348,14.789,9.328,14.674,9.326ZM6.1,10.475A.525.525,0,1,0,6.625,11,.525.525,0,0,0,6.1,10.475Zm9.8,0a.525.525,0,1,0,.525.525A.525.525,0,0,0,15.9,10.475ZM7.536,13.939a.525.525,0,1,0,.525.525A.525.525,0,0,0,7.536,13.939Zm6.929,0a.525.525,0,1,0,.525.525A.525.525,0,0,0,14.464,13.939Z",
    transform: "translate(-4 -4)",
    fill: "#202020"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.32c2b6001c6471041e080ac5980e8089.svg";
export { ForwardRef as ReactComponent };